import React, { memo } from "react";

const Modal = memo(({ open, children, onClose, className = "" }) => {
    if (!open) return null;

    return (
        <div
            onClick={onClose}
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
        >
            <div className={
                className + " bg-white rounded-lg shadow-lg relative animate-modal text-black"
            }
                onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
});

export default Modal;
